module.exports = __webpack_public_path__ + "static/media/banner.64422b1c.svg";